import { UserProfileList } from './UserProfileList';
import { UserProfileEdit } from './UserProfileEdit';
import { UserProfileShow } from './UserProfileShow';
export const userProfiles = {
    list: UserProfileList,
    edit: UserProfileEdit,
    show: UserProfileShow,
};
//# sourceMappingURL=index.js.map